import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [3.17614666774],
    [0.01353968419, 5.59313319619, 10213.285546211],
    [0.00089891645, 5.30650047764, 20426.571092422],
    [0.00005477194, 4.41630661466, 7860.4193924392],
    [0.00003455741, 2.6996444782, 11790.6290886588],
    [0.00002372061, 2.99377542079, 3930.2096962196],
    [0.00001664146, 4.25018630147, 1577.3435424478],
    [0.00001438387, 4.15745084182, 9683.5945811164],
    [0.00001317168, 5.18668228402, 26.2983197998],
    [0.00001200521, 6.15357116043, 30639.856638633],
    [0.00000769314, 0.81629615196, 9437.762934887],
    [0.0000076138, 1.95014701047, 529.6909650946],
    [0.00000707676, 1.06466702668, 775.522611324],
    [0.00000584836, 3.9983988823, 191.4482661116],
    [0.00000499915, 4.1234021282, 15720.8387848784],
    [0.00000429498, 3.58642858577, 19367.1891622328],
    [0.00000326967, 5.67736584311, 5507.5532386674],
    [0.00000326221, 4.59056477038, 10404.7338123226],
    [0.00000231937, 3.16251059356, 9153.9036160218],
    [0.00000179695, 4.65337908917, 1109.3785520934],
    [0.00000155464, 5.5704389169, 19651.048481098],
    [0.00000128263, 4.22604490814, 20.7753954924],
    [0.00000127907, 0.96209781904, 5661.3320491522],
    [0.00000105547, 1.53721203088, 801.8209311238],
    [0.00000099121, 0.83288208931, 213.299095438],
    [0.00000098804, 5.39389623302, 13367.9726311066],
    [0.00000088031, 3.88868864136, 9999.986450773],
    [0.00000085722, 0.3558924772, 3154.6870848956],
    [0.00000082094, 3.21597037872, 18837.49819713819],
    [0.00000071577, 0.11145736657, 11015.1064773348],
    [0.00000070239, 0.67458825333, 23581.2581773176],
    [0.00000056122, 4.24039842051, 7.1135470008],
    [0.00000050796, 0.24531639097, 11322.6640983044],
    [0.00000046111, 5.31576442737, 18073.7049386502],
    [0.00000044576, 6.06281108312, 40853.142184844],
    [0.00000042635, 1.79955442721, 7084.8967811152],
    [0.00000042594, 5.32873395426, 2352.8661537718],
    [0.00000041177, 0.362410122, 382.8965322232],
    [0.00000035749, 2.70448479527, 10206.1719992102],
    [0.00000033893, 2.02347385644, 6283.0758499914],
    [0.00000033252, 2.10025580495, 27511.4678735372],
    [0.00000030172, 4.94191918273, 13745.3462390224],
    [0.0000002985, 4.02177029338, 10239.5838660108],
    [0.00000029252, 3.51392387787, 283.8593188652],
    [0.0000002917, 3.59117396909, 22003.9146348698],
    [0.00000028479, 2.22375430133, 1059.3819301892],
    [0.0000002626, 0.54067510171, 17298.1823273262],
    [0.00000024424, 2.7017748784, 8624.2126509272],
    [0.00000024322, 4.27814493315, 5.5229243074],
    [0.00000023739, 4.82870820701, 6872.6731195112],
    [0.00000020492, 0.58547075036, 38.0276726358],
    [0.00000020274, 3.79493777545, 14143.4952424306],
    [0.00000019069, 6.12025555817, 29050.7837433492],
    [0.00000018988, 4.13811517967, 4551.9534970588],
    [0.00000018269, 3.04740409161, 19999.97290154599],
    [0.00000017118, 3.51922693724, 31441.6775697568],
    [0.00000015953, 1.50376176156, 8635.9420037632],
    [0.00000013656, 4.4133626499, 3532.0606928114],
    [0.00000011807, 1.91250004145, 21228.3920235458],
    [0.00000011599, 5.81007484555, 19896.8801273274],
    [0.00000011048, 2.58361219121, 9786.687355335],
    [0.00000010955, 2.84562940868, 18307.8072320436],
    [0.00000010576, 0.85419798194, 10596.1820784342],
    [0.00000010105, 2.34270729521, 10742.9765113056],
];

const VSOP87_L1: Vsop87Element = [
    [10213.28554621638],
    [0.00095617813, 2.4640651111, 10213.285546211],
    [0.00007787201, 0.6247848222, 20426.571092422],
    [0.00000173908, 2.65539499463, 26.2983197998],
    [0.00000151666, 6.10638559291, 1577.3435424478],
];

const VSOP87_L2: Vsop87Element = [
    [0.00003894209, 0.34823650721, 10213.285546211],
    [0.00000595403, 2.01456107998, 20426.571092422],
    [0.00000287868],
    [0.00000023838, 2.04588223604, 26.2983197998],
    [0.00000009964, 3.97089333901, 775.522611324],
    [0.00000007196, 3.65730119531, 30639.856638633],
    [0.00000007043, 1.52107808192, 1577.3435424478],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000136328, 4.79698723753, 10213.285546211],
    [0.00000030661, 3.71663788064, 20426.571092422],
    [0.00000000506, 5.34186957078, 30639.856638633],
    [0.00000000071, 4.27707588774, 40853.142184844],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000001636, 2.50540811485, 10213.285546211],
    [0.0000000108, 5.10106236574, 20426.571092422],
];

const VSOP87_L5: Vsop87Element = [[0.00000000122, 1.8871172463, 10213.285546211]];

const VSOP87_B0: Vsop87Element = [
    [0.05923638472, 0.26702775812, 10213.285546211],
    [0.00040107978, 1.14737178112, 20426.571092422],
    [0.00001011392, 1.0894611973, 30639.856638633],
    [0.00000149458, 6.25390268112, 18073.7049386502],
    [0.00000137788, 0.86020095586, 1577.3435424478],
    [0.00000129973, 3.67152480061, 9437.762934887],
    [0.00000119507, 3.70468787104, 2352.8661537718],
    [0.00000107971, 4.53903678347, 22003.9146348698],
    [0.00000092029, 1.53954519783, 9153.9036160218],
    [0.00000052982, 2.28138198002, 5507.5532386674],
    [0.00000045617, 0.72319646289, 10239.5838660108],
];

const VSOP87_B1: Vsop87Element = [
    [0.00287821243, 1.88964962838, 10213.285546211],
    [0.00003499578, 3.71117560516, 20426.571092422],
    [0.00001257844],
    [0.00000096152, 2.74240664188, 30639.856638633],
    [0.00000013051, 2.27549606211, 9437.762934887],
    [0.00000008052, 5.55049163175, 1577.3435424478],
];

const VSOP87_B2: Vsop87Element = [[0.00012657745, 3.34796457029, 10213.285546211], [0.00000151225]];

const VSOP87_B3: Vsop87Element = [[0.00000376505, 4.87650249694, 10213.285546211]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [0.72334820891],
    [0.00489824182, 4.02151831717, 10213.285546211],
    [0.00001658058, 4.90206728031, 20426.571092422],
    [0.00001632096, 2.84548795207, 7860.4193924392],
    [0.00001378043, 1.12846591367, 11790.6290886588],
    [0.00000498395, 2.58682193892, 9683.5945811164],
    [0.00000373958, 1.42314832858, 3930.2096962196],
    [0.00000263615, 5.52938716941, 9437.762934887],
    [0.00000237454, 2.55136053886, 15720.8387848784],
    [0.00000221985, 2.01346696541, 19367.1891622328],
    [0.00000125896, 2.72769850819, 1577.3435424478],
    [0.00000119466, 3.01975080538, 10404.7338123226],
    [0.00000085337, 3.98598666191, 19651.048481098],
    [0.00000076176, 1.59574968674, 9153.9036160218],
    [0.00000074347, 4.11957779786, 5507.5532386674],
    [0.00000042494, 3.81864493274, 13367.9726311066],
    [0.00000041902, 1.64282225331, 18837.49819713819],
    [0.00000039437, 5.39018702243, 23581.2581773176],
    [0.00000031274, 2.31806719544, 9999.986450773],
    [0.00000029042, 5.67739528728, 5661.3320491522],
    [0.00000027555, 5.72392434415, 775.522611324],
    [0.00000027288, 4.8214049462, 11015.1064773348],
    [0.00000019811, 0.53189302682, 27511.4678735372],
    [0.000000197, 4.96157560246, 11322.6640983044],
    [0.00000016214, 0.56446585474, 529.6909650946],
    [0.00000013569, 3.75536825122, 18073.7049386502],
    [0.0000001318, 3.37207825651, 13745.3462390224],
    [0.00000013066, 5.24354222739, 17298.1823273262],
];

const VSOP87_R1: Vsop87Element = [
    [0.00034551041, 0.89198706276, 10213.285546211],
    [0.00000234203, 1.77224942363, 20426.571092422],
    [0.00000023867, 1.11270233944, 9437.762934887],
    [0.00000010571, 4.59152848465, 1577.3435424478],
    [0.00000009124, 4.53540895241, 10404.7338123226],
];

const VSOP87_R2: Vsop87Element = [
    [0.00001406587, 5.06366395112, 10213.285546211],
    [0.00000015529, 5.47321056992, 20426.571092422],
];

const VSOP87_R3: Vsop87Element = [];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
